import { GetStaticPropsResult, GetServerSidePropsContext, GetStaticPathsResult } from 'next';

import { getBlogPostsByCountry } from '../../../src/api/contentful/blog/getBlogPostsByCountry';
import { getCountryByCode } from '../../../src/api/contentful/blog/getCountryByCode';
import { getRutilusGraphqlClient } from '../../../src/api/graphql/getRutilusGraphqlClient';
import { queryRutilusStatic } from '../../../src/api/graphql/queryRutilusStatic';
import { AppLogic } from '../../../src/components/AppLogic/AppLogic';
import { buildStateDataWaters } from '../../../src/components/FindUSFishingSpot/helpers/buildStateDataWaters';
import { GlobalLayout } from '../../../src/components/Layouts/GlobalLayout';
import { DISCOVER_PAGES_NAV_LINKS } from '../../../src/constants/constants';
import TOP_SIX_WATERS_BY_STATE from '../../../src/constants/fishingWaters/top6waters_by_states_23042024.json';
import { NOT_FOUND_WITH_REVALIDATION, REVALIDATE } from '../../../src/constants/next';
import { DEFAULT_US_STATE, US_STATES } from '../../../src/constants/USstates/states';
import { splitIdAndSlug } from '../../../src/helpers/urls';
import { GetCountry, GetCountryVariables } from '../../../src/interfaces/graphql';
import { IPageMetadata } from '../../../src/interfaces/nextjs';
import { getCountry } from '../../../src/queries/rutilus/Countries';
import { Country, ICountryProps } from '../../../src/views/Country/Country';

type IParams = {
  countryIdAndSlug: string;
};

const NUM_OF_TOP_WATERS = 12;

export async function getStaticProps({
  params,
}: GetServerSidePropsContext<IParams>): Promise<
  GetStaticPropsResult<IPageMetadata & ICountryProps>
> {
  const countryIdAndSlug = params?.countryIdAndSlug;

  if (!countryIdAndSlug) {
    return { notFound: true };
  }

  const id = splitIdAndSlug(countryIdAndSlug);
  const client = getRutilusGraphqlClient({ serverMode: 'static' });
  const { response } = await queryRutilusStatic<GetCountry, GetCountryVariables>(client, {
    query: getCountry,
    variables: { id, limit: NUM_OF_TOP_WATERS },
  });

  if (!response) {
    return NOT_FOUND_WITH_REVALIDATION;
  }
  const stateWaterData = buildStateDataWaters(TOP_SIX_WATERS_BY_STATE);
  const result = await getCountryByCode(id.toUpperCase());
  const blogPostItems = result ? await getBlogPostsByCountry(3, result.sys.id) : undefined;

  return {
    props: {
      _page: 'country',
      _pageTitle: 'Country',
      country: response.data.entry,
      usStates: US_STATES,
      defaultUSState: DEFAULT_US_STATE,
      stateWaterData,
      blogPostItems: blogPostItems ? blogPostItems.items : [],
    },
    revalidate: REVALIDATE.DAILY,
  };
}

export async function getStaticPaths(): Promise<GetStaticPathsResult<IParams>> {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

Country.getLayout = function getLayout(page: any) {
  return (
    <AppLogic pageProps={page.props}>
      <GlobalLayout siteSubNavigationLinks={DISCOVER_PAGES_NAV_LINKS}>{page}</GlobalLayout>
    </AppLogic>
  );
};

export default Country;
